import extraColorsBundle from "components/ui/colors/extraColorsBundle";
import { default as nativeTailwindColors } from "tailwindcss/colors";
import type { DefaultColors } from "tailwindcss/types/generated/colors";

const TAILWIND_COLORS: Partial<DefaultColors> = nativeTailwindColors;
delete TAILWIND_COLORS.blueGray;
delete TAILWIND_COLORS.coolGray;
delete TAILWIND_COLORS.trueGray;
delete TAILWIND_COLORS.warmGray;
delete TAILWIND_COLORS.lightBlue;

const NATIVE_TAILWIND_COLOR_NAMES = [
  "slate",
  "gray",
  "zinc",
  "neutral",
  "stone",
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "sky",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
];

const colorsBundle = {
  ...Object.entries(TAILWIND_COLORS)
    .filter(([name]) => NATIVE_TAILWIND_COLOR_NAMES.includes(name))
    .reduce((state, [name, colors]) => {
      return {
        ...state,
        [name]: colors,
      };
    }, {}),
  ...extraColorsBundle,
};

export const tailwindColors = Object.freeze(colorsBundle) as Record<
  | "slate"
  | "gray"
  | "zinc"
  | "neutral"
  | "stone"
  | "red"
  | "orange"
  | "amber"
  | "yellow"
  | "lime"
  | "green"
  | "emerald"
  | "teal"
  | "cyan"
  | "sky"
  | "blue"
  | "indigo"
  | "violet"
  | "purple"
  | "fuchsia"
  | "pink"
  | "rose"
  | keyof typeof extraColorsBundle,
  Record<50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950, string>
>;
